import { plotDataFeature } from './plot-data.reducer'

export const {
    selectMarkerX,
    selectMarkerY,
    selectMarkerColor,
    selectIsLoadingPlotData,
    selectPointSize,
    selectPointOpacity,
    selectLassoType,
} = plotDataFeature
